// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4223) return "static/chunks/commons-64a7a4cbfe740282.js";
	if (chunkId === 5239) return "static/chunks/5239-64a7a4cbfe740282.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".64a7a4cbfe740282.js";
};